module.exports = __webpack_public_path__ + "static/media/city1.ebc5562d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/utils/images/sidebar/city1.jpg
// module id = ./src/assets/utils/images/sidebar/city1.jpg
// module chunks = 7